import { render, staticRenderFns } from "./DisplayContactDetails.vue?vue&type=template&id=dd0fd0ec"
import script from "./DisplayContactDetails.vue?vue&type=script&lang=js"
export * from "./DisplayContactDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports